import DialogTitle from '@components/mui/DialogTitle'
import { faGear } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	Box,
	Dialog,
	DialogContent,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography,
	useColorScheme,
} from '@mui/material'
import { DialogProps, useDialogs } from '@toolpad/core'

import NavButton from './NavButton'

function ProfileSettingsDialog({ open, onClose }: DialogProps) {
	const { mode, setMode } = useColorScheme()
	return (
		<Dialog open={open} closeAfterTransition={false} disableRestoreFocus>
			<DialogTitle onClose={() => onClose(null)}>Profile Settings</DialogTitle>
			<DialogContent data-testid="profile-settings">
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<FormControl>
						<Typography>Theme</Typography>
						<RadioGroup
							name="theme-toggle"
							row
							value={mode}
							onChange={(event) => setMode(event.target.value as 'light' | 'dark' | 'system')}
						>
							<FormControlLabel
								value="system"
								control={<Radio />}
								label="System"
								data-testid="system"
							/>
							<FormControlLabel
								value="light"
								control={<Radio />}
								label="Light"
								data-testid="light"
							/>
							<FormControlLabel value="dark" control={<Radio />} label="Dark" data-testid="dark" />
						</RadioGroup>
					</FormControl>
				</Box>
			</DialogContent>
		</Dialog>
	)
}

export default function ProfileSettings() {
	const dialogs = useDialogs()
	return (
		<NavButton
			icon={<FontAwesomeIcon style={{ height: '1.5rem' }} size="xl" icon={faGear} />}
			primary="Profile Settings"
			onClick={() => dialogs.open(ProfileSettingsDialog)}
			data-testid="sidebar-profile-settings"
		/>
	)
}
